// src/pages/SelectionOrders/components/tables/SelectionOrderDataTable.tsx
import React from 'react';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import useSelectionOrderService from '../../../../app/services/hooks/useSelectionOrderService';
import { SelectionOrderDataForm, SelectionOrderFilters } from '../../../../app/models/SelectionOrder';
import SelectionOrderFilter from './SelectionOrderFilter';

interface Props {
  items: SelectionOrderDataForm[];
  totalRows: number;
  loading?: boolean;
  edit?: (id: number) => void;
  show?: (id: number) => void;
  destroy?: (id: number) => void;
  filter: SelectionOrderFilters;
  setFilter: (filter: SelectionOrderFilters) => void;
  callbackSuccess: () => void;
}

const ActiveToggle: React.FC<{ id: number; value?: boolean; onDone: () => void }> = ({ id, value, onDone }) => {
  const { activeSelectionOrder } = useSelectionOrderService();
  return (
    <input
      type="checkbox"
      checked={!!value}
      onChange={(e) => {
        activeSelectionOrder(id, e.target.checked, {
          onSuccess: () => onDone(),
          onError: () => onDone()
        });
      }}
    />
  );
};

const SelectionOrderDataTable = ({
  items, totalRows, loading = false, edit, show, destroy, filter, setFilter, callbackSuccess
}: Props) => {
  const columns = [
    {
      name: 'Id',
      selector: (row: any) => row.id,
      sortable: true,
      sortField: 'id',
      cell: (row: SelectionOrderDataForm) => <span>{row.id}</span>
    },

    {
      name: 'Sociedad',
      selector: (row: any) => row.society,
      sortable: true,
      sortField: 'society__name',
      cell: (row: SelectionOrderDataForm) => <span>{row.society}</span>
    },

    {
      name: 'Fecha programa',
      selector: (row: any) => row.program_date ?? '',
      sortable: true,
      sortField: 'program_date',
      cell: (row: SelectionOrderDataForm) => <span>{row.program_date ?? '—'}</span>
    },

    {
      name: 'Inicio',
      selector: (row: any) => row.start_date ?? '',
      sortable: true,
      sortField: 'start_date',
      cell: (row: SelectionOrderDataForm) => <span>{row.start_date ?? '—'}</span>
    },

    {
      name: 'Estado',
      selector: (row: any) => row.status_label ?? row.status,
      sortable: true,
      sortField: 'status',
      cell: (row: SelectionOrderDataForm) => <span>{row.status_label ?? row.status}</span>
    },
    
    {
      name: 'Acciones',
      selector: (row: any) => row.id,
      sortable: false,
      cell: (row: SelectionOrderDataForm) => (
        <div>
          {show && (
            <ButtonTableAction
              callbackFunction={() => show(row.id ?? -1)}
              classIcon="mdi mdi-eye"
              colorIcon="text-info"
              title="Ver"
            />
          )}
          {edit && (
            <ButtonTableAction
              callbackFunction={() => edit(row.id ?? -1)}
              classIcon="mdi mdi-pencil"
              colorIcon="text-warning"
              title="Editar"
            />
          )}
          {destroy && (
            <ButtonTableAction
              callbackFunction={() => destroy(row.id ?? -1)}
              classIcon="mdi mdi-delete"
              colorIcon="text-danger"
              title="Eliminar"
            />
          )}
        </div>
      )
    }
  ];

  return (
    <>
      <div className="row mt-3">
        <div className="col">
          <SelectionOrderFilter
            filter={filter}
            setFilter={setFilter}
            onSearch={callbackSuccess}
          />
        </div>
      </div>
      <DefaultDataTable
        columns={columns}
        data={items}
        progressPending={loading}
        paginationTotalRows={totalRows}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default SelectionOrderDataTable;